/* eslint-disable */
import * as React from 'react';

import AppPage from '@/ui/AppPage/AppPage';
import UserForm from './UserForm';
import Box from '@mui/material/Box';
import Permissions from '@/lib/permissions';

import { useParams } from 'react-router-dom';
import dataController from '@/lib/DataController';
import model from '@/models/user';

function UserPage() {
  const { id } = useParams();
  const dc = new dataController(model);

  const recordId = parseInt(id ? id : '', 10);

  return (
    <AppPage titlett="page.user" needPermission={[Permissions.Administration]}>
      <Box m={2}>
        <UserForm dc={dc} recordId={recordId} mode="update" form="update" />
      </Box>
    </AppPage>
  );
}

export default UserPage;
